/**
 * siteData.js - single source of truth for all content in the site.
 *
 * TODO markers indicate placeholders that Dhairya will replace with real
 * content (friend one-lines, photos, wishes, fun facts, etc.).
 */

export const siteData = {
  megha: {
    name: 'Megha Mattikalli',
    nickname: 'Jups',
    dob: '1998-04-02',
    age: 28,
    birthplace: {
      city: 'Bangalore',
      state: 'Karnataka',
      country: 'India',
      lat: 12.9716,
      lon: 77.5946,
      timezone: 'Asia/Kolkata',
      birthTimeIST: '00:00',
    },
    currentCity: 'Seattle, USA',
  },

  family: [
    {
      id: 'father',
      name: 'Ishwarappa Mattikalli',
      role: 'father',
      starType: 'calm-golden',
      photo: '/photos/family/father.jpg', // TODO
    },
    {
      id: 'mother',
      name: 'Sheela Haveri',
      role: 'mother',
      starType: 'binary-mass-transfer',
      photo: '/photos/family/mother.jpg', // TODO
    },
    {
      id: 'brother',
      name: 'Ganesh',
      role: 'brother',
      age: 22,
      starType: 'companion',
      photo: '/photos/family/ganesh.jpg', // TODO
    },
  ],

  homePlanets: {
    kerala: {
      id: 'kerala',
      label: 'Kerala',
      subtitle: 'First home',
      texture: '/textures/kerala-planet.jpg', // TODO
      photos: [], // TODO: childhood photos
      friends: [
        { name: 'Sree', isBest: true, oneLine: 'TODO', photo: null },
        { name: 'Abhi', oneLine: 'TODO', photo: null },
        { name: 'Arun', oneLine: 'TODO', photo: null },
        { name: 'Hrishika', oneLine: 'TODO', photo: null },
      ],
    },
    bangalore: {
      id: 'bangalore',
      label: 'Bangalore',
      subtitle: 'Second home',
      texture: '/textures/bangalore-planet.jpg', // TODO
      photos: [], // TODO: college photos
      friends: [
        { name: 'Dhairya', oneLine: 'TODO (written by Dhairya himself)', photo: null },
        { name: 'Sadia', oneLine: 'TODO', photo: null },
        { name: 'Shalini', oneLine: 'TODO', photo: null },
        { name: 'Garvit', oneLine: 'TODO', photo: null },
      ],
    },
    seattle: {
      id: 'seattle',
      label: 'Seattle',
      subtitle: 'Third home',
      texture: '/textures/seattle-planet.jpg', // TODO
      photos: [], // TODO: Seattle life photos
      friends: [
        { name: 'Bhagi', oneLine: 'TODO', photo: null },
        { name: 'Rohit', oneLine: 'TODO', photo: null },
        { name: 'Tarun', oneLine: 'TODO', photo: null },
        { name: 'Anand', oneLine: 'TODO', photo: null },
        { name: 'Divya', oneLine: 'TODO', photo: null },
        { name: 'Animesh', oneLine: 'TODO', photo: null },
        { name: 'Bansari', oneLine: 'TODO', photo: null },
        { name: 'Anshul', oneLine: 'TODO', photo: null },
        { name: 'Nova', oneLine: 'TODO', photo: null },
        { name: 'Thibaud', oneLine: 'TODO', photo: null },
        { name: 'Chiradeep', oneLine: 'TODO', photo: null },
      ],
      surfaceObjects: [
        { id: 'cascades', label: 'the Cascades' },
        { id: 'studio', label: 'the dance studio' },
        { id: 'trails', label: 'the hiking trails' },
        { id: 'pool', label: 'the pool' },
      ],
    },
  },

  jimmy: {
    name: 'Jimmy',
    breed: 'Lab',
    sex: 'male',
    gotDate: '2020-12',
    photo: '/photos/jimmy.jpg', // TODO
    starName: 'Sirius',
  },

  birthStar: {
    targetDistanceLightYears: 28,
    earliestPhoto: '/photos/megha-baby.jpg', // TODO
    // The actual star (name, position) gets resolved at runtime against HYG catalog
    resolved: null,
  },

  music: [
    { id: 'body-to-body',   title: 'Body to Body',                 artist: 'BTS',          file: '/music/body-to-body.mp3',   role: 'radio' },
    { id: 'cypher-4',       title: 'Cypher 4',                     artist: 'BTS',          file: '/music/cypher-4.mp3',       role: 'radio' },
    { id: 'fake-love-rmx',  title: 'FAKE LOVE (Rocking Vibe Mix)', artist: 'BTS',          file: '/music/fake-love-rmx.mp3',  role: 'radio' },
    { id: 'still-with-you', title: 'Still With You',               artist: 'Jung Kook',    file: '/music/still-with-you.mp3', role: 'radio' },
    { id: 'nuevayol',       title: 'NUEVAYoL',                     artist: 'Bad Bunny',    file: '/music/nuevayol.mp3',       role: 'radio' },
    { id: 'heat-waves',     title: 'Heat Waves (Slowed)',          artist: 'Glass Animals', file: '/music/heat-waves.mp3',    role: 'radio' },
    { id: 'belly-dancer',   title: 'Belly Dancer',                 artist: 'Imanbek',      file: '/music/belly-dancer.mp3',   role: 'radio' },
    { id: 'blank-space',    title: 'Blank Space',                  artist: 'Taylor Swift', file: '/music/blank-space.mp3',    role: 'radio' },
    { id: 'wildest-dreams', title: 'Wildest Dreams',               artist: 'Taylor Swift', file: '/music/wildest-dreams.mp3', role: 'radio' },
    { id: 'baile',          title: 'BAILE INoLVIDABLE',            artist: 'Bad Bunny',    file: '/music/baile.mp3',          role: 'pulsar', bpm: 95 },
    { id: 'supermassive',   title: 'Supermassive Black Hole',      artist: 'Muse',         file: '/music/supermassive.mp3',   role: 'blackhole-descent' },
    { id: 'mikrokosmos',    title: 'Mikrokosmos',                  artist: 'BTS',          file: '/music/mikrokosmos.mp3',    role: 'finale' },
    { id: 'ambient',        title: 'Ambient Loop',                 artist: '-',            file: '/music/ambient.mp3',        role: 'ambient', loop: true },
  ],

  travel: [
    { id: 'singapore',   name: 'Singapore',   landmark: 'marina-bay',  photo: null, memory: 'TODO', era: 'family' },
    { id: 'dubai',       name: 'Dubai',       landmark: 'burj',        photo: null, memory: 'TODO', era: 'family' },
    { id: 'london',      name: 'London',      landmark: 'big-ben',     photo: null, memory: 'TODO', era: 'solo' },
    { id: 'edinburgh',   name: 'Edinburgh',   landmark: 'castle',      photo: null, memory: 'TODO', era: 'solo' },
    { id: 'miami',       name: 'Miami',       landmark: 'beach-palm',  photo: null, memory: 'TODO', era: 'solo' },
    { id: 'yellowstone', name: 'Yellowstone', landmark: 'geyser',      photo: null, memory: 'TODO', era: 'solo' },
  ],

  wishes: [
    // TODO: collect 18-22 real wishes from family + friends
    // Order: any order. Dhairya's wish has isFinal=true and is held back until ~80% caught.
    // Format: { id, name, text, isFinal? }
  ],

  funFacts: [
    // TODO: 30-50 specific fun facts about Megha (only-her-closest-people-would-know)
  ],

  easterEggs: [
    {
      id: 'first-conversation',
      type: 'binary-star',
      placement: 'near-bangalore-planet',
      date: '2017-03-28',
      yearsAgo: 9, // verify at ship time
      text: 'This is the day we first spoke. The light from this star is exactly nine years old.',
      after: 'You were nineteen. You did not know yet.',
      photos: [], // TODO
    },
    {
      id: 'd-day',
      type: 'hidden-point',
      placement: 'quiet-corner',
      date: '2019-03-03',
      text: 'D-Day.',
    },
    { id: '40-eridani', type: 'real-star', starName: '40 Eridani', text: 'Hi, question?' },
    { id: 'tau-ceti',   type: 'real-star', starName: 'Tau Ceti',   text: 'The destination.' },
    { id: 'hail-mary-ship', type: 'drifting-silhouette', text: 'They made it home.' },
    { id: 'astrophage', type: 'particle-glow', placement: 'near-sun-equivalent', text: 'Microscopic life. Hungry. They figured it out.' },
    { id: 'xenonite',   type: 'faceted-object', text: 'Built by hand. Built with care.' },
    { id: 'fistbump',   type: 'two-points', text: 'Fistbump.' },
  ],

  finale: {
    cosmicMessage: 'Happy birthday, Megha.',
    closing: [
      'You are 28 years of starlight.',
      'Every step you have danced, every place you have gone, every person you have loved, every black hole you have read about - all of it has been arriving at you at once.',
      'This is what you are made of.',
      'Look up. There you are.',
    ],
  },
};
